(() => {
  if (customElements.get('shipping-progress')) return;
  let timer;
  let generation = 0;
  const format = cents => new Intl.NumberFormat('pl-PL', {style:'currency',currency:'PLN'}).format(cents / 100);
  const refresh = () => {
    clearTimeout(timer);
    const current = ++generation;
    timer = setTimeout(async () => {
      const widget = document.querySelector('shipping-progress');
      if (!widget) return;
      try {
        const root = widget.dataset.root || '/';
        const response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', {headers:{Accept:'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        if (current !== generation) return;
        document.querySelectorAll('shipping-progress').forEach(element => element.update(cart));
      } catch (_) { /* Keep the server-rendered information on network failure. */ }
    }, 150);
  };
  class ShippingProgress extends HTMLElement {
    connectedCallback() { refresh(); }
    update(cart) {
      if (cart.currency !== 'PLN') { this.hidden = true; return; }
      this.hidden = false;
      const goal = Number(this.dataset.goal);
      if (!(goal > 0)) return;
      const remaining = Math.max(0, goal - cart.total_price);
      const message = this.querySelector('[data-shipping-message]');
      if (message) {
        message.replaceChildren();
        const strong = document.createElement('strong');
        strong.textContent = remaining ? format(remaining) : 'Darmowa dostawa odblokowana!';
        if (remaining) message.append('Do darmowej dostawy brakuje Ci ');
        message.append(strong);
      }
      const progress = this.querySelector('progress');
      if (progress) progress.value = Math.min(100, Math.max(0, cart.total_price / goal * 100));
    }
  }
  customElements.define('shipping-progress', ShippingProgress);
  document.addEventListener('shopify:cart:lines-update', refresh);
  document.addEventListener('cart-section:restored', refresh);
  window.addEventListener('pageshow', refresh);
})();
